define('companiesDetailBodyOrdersView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'ordersListView',
  'entities/companies/companies'
], function (
  App,
  Module,
  _,
  $,
  ListView
) {
  'use strict';

  // Aggregated orders of every sub-account (EndUser) of the company.
  // Reuses the rich orders table; only the data source (fetch/fetchCount) is swapped
  // to hit the company endpoints. Advanced filters are not applied server-side here.
  Module.exports = ListView.extend({
    className: 'company-detail-orders-view ' + ListView.prototype.className,

    fetch: function (first, pageSize) {
      var defer = $.Deferred();

      if (this.fetchRequest) {
        this.fetchRequest.abort();
      }

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('company:orders-url', this.options.companySecId, {first: first, pageSize: pageSize}),
        success: _.bind(function (items) {
          var models = [];
          _.each(items, _.bind(function (item) {
            models.push(App.request('order:model', App.request('order:parse-list-data', item)));
          }, this));
          defer.resolve(models);
        }, this)
      });

      return defer.promise();
    },

    fetchCount: function () {
      var defer = $.Deferred();

      if (this.fetchCountRequest) {
        this.fetchCountRequest.abort();
      }

      this.fetchCountRequest = $.ajax({
        type: 'GET',
        url: App.request('company:orders-count-url', this.options.companySecId),
        success: _.bind(function (counts) {
          defer.resolve(counts.totalCount);
        }, this)
      });

      return defer.promise();
    }
  });
});

